import React, { useState, useEffect } from "react";
import "../static/css/AdminControl.css";

function AdminControlPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const response = await fetch("https://ibcbackend.quindl.com/users");
      const data = await response.json();
      setAdmins(data);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this admin user?")) {
      try {
        const response = await fetch(`https://ibcbackend.quindl.com/users/${id}`, {
          method: "DELETE",
        });
        if (response.ok) {
          alert("Admin deleted successfully");
          fetchAdmins();
        } else {
          alert("Failed to delete admin");
        }
      } catch (error) {
        console.error("Error deleting admin:", error);
      }
    }
  };

  const handleEdit = (admin) => {
    setName(admin.username);
    setEmail(admin.emailid);
    setPassword(""); // Keep password empty for security, user can set new one
    alert("Edit mode activated for: " + admin.username);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newAdmin = {
      username: name,
      emailid: email,
      password,
    };

    try {
      const response = await fetch("https://ibcbackend.quindl.com/users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newAdmin),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("New admin created:", result);
        alert("New admin added successfully");
        setName("");
        setEmail("");
        setPassword("");
        setErrorMessage("");
        fetchAdmins();
      } else {
        const errorText = await response.text();
        setErrorMessage(errorText);
      }
    } catch (error) {
      console.error("Error adding admin:", error);
      setErrorMessage("An error occurred while adding admin.");
    }
  };

  return (
    <>
      <div className="Admincontrol" style={{ padding: "40px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div className="admincontrol-form" style={{ width: "50%", minWidth: "400px", background: "white", padding: "30px", borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
          <h3>Add New Admin User</h3>
          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              style={{ width: "100%", padding: "10px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ddd" }}
            />

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              style={{ width: "100%", padding: "10px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ddd" }}
            />

            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              style={{ width: "100%", padding: "10px", marginBottom: "20px", borderRadius: "5px", border: "1px solid #ddd" }}
            />

            <button type="submit" style={{ width: "100%", padding: "12px", background: "#000", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" }}>Add New Admin</button>
          </form>
          {errorMessage && <p className="error-message" style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>}
        </div>

        <div className="admin-list" style={{ width: "80%", marginTop: "50px" }}>
            <h3>Existing Admin Users</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
                {admins.map((admin) => (
                    <div key={admin.id} style={{ background: "white", padding: "20px", borderRadius: "10px", boxShadow: "0 2px 5px rgba(0,0,0,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                            <h4 style={{ margin: "0" }}>{admin.username}</h4>
                            <p style={{ margin: "5px 0 0 0", color: "#666", fontSize: "0.9em" }}>{admin.emailid}</p>
                        </div>
                        <div className="item-actions">
                          <button 
                            className="edit-btn"
                            onClick={() => handleEdit(admin)}
                          >
                            Edit
                          </button>
                          <button 
                            className="delete-btn"
                            onClick={() => handleDelete(admin.id)}
                          >
                            Delete
                          </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
      </div>
    </>
  );
}

export default AdminControlPage;
